<template>
  <div class="h-100 p-0 m-0">
    <div class="col-12 p-0 m-0">
      <div class="card padding-20">
        <div class="d-flex align-items-center justify-content-between mb-4 pb-2 border-bottom">
          <div class="d-flex align-items-center">
            <h5 class="m-0 font-weight-bold">
              {{ isEditing ? 'Խմբագրել ստորաբաժանում' : 'Ավելացնել ստորաբաժանում' }}
            </h5>
          </div>
        </div>

        <form @submit.prevent="submitForm">
          <div class="row">
            <!-- Անվանում -->
            <div class="col-md-6 mb-3">
              <label class="font-weight-medium">Անվանում *</label>
              <input
                type="text"
                class="form-control"
                :class="{'is-invalid': errors.name}"
                v-model="form.name"
                placeholder="Անվանում"
              />
              <div v-if="errors.name" class="invalid-feedback">{{ errors.name }}</div>
            </div>
          </div>

          <!-- Buttons -->
          <div class="d-flex justify-content-end mt-4 pt-3 border-top">
            <button type="submit" class="btn btn-primary px-4" :disabled="submitting">
              <span v-if="submitting" class="spinner-border spinner-border-sm mr-1"></span>
              Պահպանել
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OrganisationUnitForm',
  data() {
    return {
      isEditing: false,
      unitId: null,
      loadingUnit: false,
      submitting: false,
      form: {
        name: '',
      },
      errors: {},
    }
  },
  mounted() {
    this.unitId = this.$route.params.id || null
    this.isEditing = Boolean(this.unitId)
    if (this.isEditing) {
      this.fetchUnit()
    }
  },
  methods: {
    goBack() {
      this.$router.push('/organisation-units')
    },
    async fetchUnit() {
      this.loadingUnit = true
      try {
        const { data } = await this.$client.get(`organisation-units/${this.unitId}`)
        const unit = data.data
        this.form.name = unit.name || ''
      } catch (e) {
        this.$notify({
          group: 'foo',
          type: 'error',
          text: 'Ստորաբաժանման տվյալները բեռնել չհաջողվեց',
        })
        this.goBack()
      } finally {
        this.loadingUnit = false
      }
    },
    validate() {
      this.errors = {}
      if (!this.form.name || !this.form.name.trim()) {
        this.errors.name = 'Անվանումը պարտադիր է'
      }
      return Object.keys(this.errors).length === 0
    },
    async submitForm() {
      if (!this.validate()) return
      this.submitting = true
      try {
        const payload = {
          name: this.form.name.trim(),
        }
        if (this.isEditing) {
          await this.$client.put(`organisation-units/${this.unitId}`, payload)
          this.$notify({
            group: 'foo',
            type: 'success',
            text: 'Ստորաբաժանումը հաջողությամբ թարմացվել է',
          })
        } else {
          await this.$client.post('organisation-units', payload)
          this.$notify({
            group: 'foo',
            type: 'success',
            text: 'Ստորաբաժանումը հաջողությամբ ստեղծվել է',
          })
        }
        this.goBack()
      } catch (e) {
        if (e && e.data && e.data.errors) {
          const serverErrors = e.data.errors
          for (const key in serverErrors) {
            this.$set(this.errors, key, serverErrors[key][0])
          }
        } else {
          this.$notify({
            group: 'foo',
            type: 'error',
            text: (e && e.data && e.data.message) || 'Սխալ է տեղի ունեցել',
          })
        }
      } finally {
        this.submitting = false
      }
    },
  },
}
</script>
